import { Box, Button, Checkbox, FormControlLabel, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { clickElement, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import moment from 'moment'
import EditIcon from '@mui/icons-material/Edit'
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { updateAlertError } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { billingUnitList, cellStyles, serviceTypeList, statusListWithAll } from '../constants'
import AddNewPartyRatesModal from './AddNewPartyRatesModal'
import { getFocApprConsTypeData, getPartyConfigTableData, getPartyRateMatrixTableData, getParyRateUpdate } from '../../../../../store/generalSetting/GSAction'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { getCityList } from '../../../../../store/branchAndUserMaster/BUMAction'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'

const PartyRateMatrixTable = (props) => {
  const { data, updateAlertError, getFocApprConsTypeData, getPartyConfigTableData, getPartyRateMatrixTableData, getParyRateUpdate, getCityList } = props
  const { common, generalSettingReducer } = data
  const { loginData } = common
  const { focApprConsTypeData, partyConfigTableData } = generalSettingReducer
  const [tableData, setTableData] = useState([])
  const [filteredData, setfilteredData] = useState(tableData)
  const [manageFocus, setManageFocus] = useState(false)
  const [showAddPartyRateModal, setShowAddPartyRateModal] = useState(false)
  const [addPartyRateData, setAddPartyRateData] = useState({})
  const [consTypeList, setConsTypeList] = useState([])
  const [partyList, setPartyList] = useState([])
  const [filters, setFilters] = useState({ partyName: '', serviceType: serviceTypeList?.[0], consignmentType: '', billingUnit: billingUnitList?.[0], status: statusListWithAll?.[0] })
  const [editData, setEditData] = useState({})
  const [isSuccess, setIsSuccess] = useState(false)
  const [cityList, setCityList] = useState([])
  const [searchData, setSearchData] = useState({
    PartyID: "",
    Party: "",
    ServiceTypeID: "",
    ServiceType: "",
    ConsignmentID: "",
    ConsignmentType: "",
    BillingUnitName: "",
    SourceCity: "",
    DestinationCity: "",
    assignedRate: "",
    ModifiedBy: "",
    ModifiedDate: ''
  })
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  useEffect(() => {
    focusElemnt('selectParty')
  }, [])

  const getAddPartyRatesModalInfo = () => {
    let data = {
      loginData: loginData,
      filters: filters,
      cityList: cityList
    }
    setShowAddPartyRateModal(true)
    setAddPartyRateData(data)
  }

  const columnDefs = [
    { headerName: 'S/N', field: 'SN', headerSx: { padding: '6px', textAlign: 'right', minWidth: '2.54%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Party\nID', field: 'PartyID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.42%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Party\nName', field: 'Party', headerSx: { padding: '6px', textAlign: 'left', minWidth: '10.41%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Service \nType ID', field: 'ServiceTypeID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.94%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Service\nType ', field: 'ServiceType', headerSx: { padding: '6px', textAlign: 'left', minWidth: '7.04%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Cons.\nType ID', field: 'ConsignmentID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '5.2%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Consignment\nType ', field: 'ConsignmentType', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Billing\nUnit ', field: 'BillingUnitName', headerSx: { padding: '6px', textAlign: 'left', minWidth: '7.04%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Source\nCity', field: 'SourceCity', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.47%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Destination\nCity', field: 'DestinationCity', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.47%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Assigned\nRate', field: 'assignedRate', headerSx: { padding: '6px', textAlign: 'right', minWidth: '5.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Modified\nBy', field: 'ModifiedBy', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Mod. Date\n& Time', field: 'ModifiedDate', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.77%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Status', field: 'active', headerSx: { padding: '6px', textAlign: 'center', minWidth: '4.34%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Edit', field: 'edit', headerSx: { padding: '6px', textAlign: 'left', minWidth: '%' }, dataType: 'string', showfilter: false, allowSorting: false },
  ]
  const columnDefs1 = [
    { headerName: 'S/N', field: 'SN', headerSx: { padding: '6px', textAlign: 'right', minWidth: '2.54%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Party\nID', field: 'PartyID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.42%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Party\nName', field: 'Party', headerSx: { padding: '6px', textAlign: 'left', minWidth: '10.41%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Service \nType ID', field: 'ServiceTypeID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.94%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Service\nType ', field: 'ServiceType', headerSx: { padding: '6px', textAlign: 'left', minWidth: '7.04%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Cons.\nType ID', field: 'ConsignmentID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '5.2%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Consignment\nType ', field: 'ConsignmentType', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Billing\nUnit ', field: 'BillingUnitName', headerSx: { padding: '6px', textAlign: 'left', minWidth: '7.04%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Source\nCity', field: 'SourceCity', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.47%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Destination\nCity', field: 'DestinationCity', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.47%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Assigned\nRate', field: 'assignedRate', headerSx: { padding: '6px', textAlign: 'right', minWidth: '5.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Modified\nBy', field: 'ModifiedBy', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Mod. Date\n& Time', field: 'ModifiedDate', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.77%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Status', field: 'active', headerSx: { padding: '6px', textAlign: 'center', minWidth: '4.34%' }, dataType: 'string', showfilter: false, allowSorting: false },
  ]

  useEffect(() => {
    getTableData()
  }, [])
  useEffect(() => setfilteredData(tableData), [tableData])
  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={15}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>No results found.</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let obj = {
        intConsignmentSubTypeID: 0,
        intCompanyID: loginData?.intCompanyID,
        intConsignmentTypeID: 0,
        strSubType: "",
        intIsActive: 1,
        intIsDeleted: 0
      }
      getFocApprConsTypeData(obj, true, 24 * 60 * 60 * 1000)


      let object = {
        intPartyID: 0,
        intCompanyID: loginData?.intCompanyID,
        strPartyName: "",
        strContactPerson: "",
        intCityID: 0,
        intIsCreditParty: -1,
        intIsActive: -1,
        intIsDeleted: -1
      }
      getPartyConfigTableData(object)

      let body1 = {
      }
      getCityList(body1, true, 24 * 60 * 60 * 1000).then((res) => {
        if (res.status === 'Success') {
          let newData = removeDuplicatesFromArray(res.Data.Table, 'CityID')
          const cityNames = newData.map(city => ({ CityID: city.CityID, CityName: city.Cityname }));
          setCityList(cityNames)
        } else {
          setCityList([])
        }
      }).catch((err) => {
        console.log('Error:', err)
      })
    }
  }, [loginData])
  useEffect(() => {

  }, [loginData])
  const getTableData = () => {
    let obj = {
      PartyID: filters?.partyName?.PartyID,
      CompanyID: loginData?.intCompanyID,
      ConsignmentTypeID: filters?.consignmentType?.id,
      ServiceTypeID: filters?.serviceType?.id,
      BillingUnit: filters?.billingUnit?.id,
      IsActive: filters?.status?.id
    }
    getPartyRateMatrixTableData(obj).then((res) => {
      if (res.status === 'Success') {
        let data = res?.Data?.Table
        let newData = data?.map((val, i) => ({ ...val, editBtn: true, assignedRate: val.Rate, active: val.IsActive, ModifiedDate: val.ModifiedDatetime === '' || val.ModifiedDatetime === null || val.ModifiedDatetime === undefined ? '' : moment(val.ModifiedDatetime).format('DD-MMM-YYYY, HH:mm') }))
        setTableData(newData)
      }
      else {
        setTableData([])
      }
    }).catch((err) => {
      updateAlertError({ show: true, msg: err, nextId: '' })
      console.log("Error:", err)
    })
  }
  useEffect(() => {
    if (focApprConsTypeData?.length > 0) {
      let newData = [{ id: -1, name: 'All' }]
      focApprConsTypeData.map(function (obj) {
        newData.push({
          id: obj.ConsignmentSubTypeID,
          name: obj.SubType,
        })
      })
      newData = removeDuplicatesFromArray(newData, `id`)
      newData.sort((a, b) => a.name.localeCompare(b.name))
      setConsTypeList(newData)
      setFilters((prev) => ({
        ...prev,
        consignmentType: newData?.[0],
      }))
    } else {
      setConsTypeList([])
    }
  }, [focApprConsTypeData])
  useEffect(() => {
    if (partyConfigTableData?.length > 0) {
      setPartyList(partyConfigTableData)
      setFilters((prev) => ({
        ...prev,
        partyName: partyConfigTableData?.[0],
      }))
    } else {
      setPartyList([])
    }
  }, [partyConfigTableData])
  const handleHideEditBtn = (index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      for (let i = 0; i < newVal?.length; i++) {
        if (i === index) {
          newVal[i].editBtn = !newVal[i].editBtn
        } else {
          newVal[i].editBtn = true
        }
      }
      setfilteredData(newVal)
      focusElemnt(`editBtn-${index + 1}`)
      newVal[index].editBtn === true ? setManageFocus(false) : setManageFocus(true)
    }
  }
  const handleRowChkChange = (e, index) => {
    setManageFocus(false)
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].active = e.target.checked ? 1 : 0
      setfilteredData(newVal)
    }
    setTimeout(() => {
      focusElemnt(`chkbox-${index}`)
    }, 0)
  }
  const handleRowEdit = (row, index) => {
    if (row?.assignedRate === '') {
      updateAlertError({ show: true, msg: 'Please Enter Assigned Rate', success: false, nextId: `prmRate-${index}` })
      return
    } else {
      let newVal = [...filteredData]
      let obj = {
        CompanyID: loginData?.intCompanyID,
        PartyID: row?.PartyID,
        ConsignmentID: row?.ConsignmentID,
        UserID: loginData?.intUserID,
        FromCityID: row?.SourceCityID,
        ToCityID: row?.DestinationCityID,
        ServiceTypeID: row?.ServiceTypeID,
        BillingUnit: row?.BillingUnit,
        Rate: row?.assignedRate,
        Active: row?.active
      }
      getParyRateUpdate(obj)?.then((res) => {
        if (res?.status == 'Success') {
          setIsSuccess(true)
          if (index >= 0 && index <= newVal?.length) {
            newVal[index].editBtn = !newVal[index].editBtn
            setfilteredData(newVal)
          }
        } else {
          updateAlertError({ show: true, msg: res.Message, success: false, nextId: `focApprConsType` })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
  }
  const handleCrossBtn = (index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].assignedRate = filteredData[index].Rate
      newVal[index].active = filteredData[index].IsActive
      newVal[index].editBtn = !newVal[index].editBtn
      setfilteredData(newVal)
      setTimeout(() => {
        focusElemnt(`editBtn-${index + 1}`)
      }, 0)
    }
  }
  const handleInputChange = (e, index) => {
    // let value = e.target.value.replace(/[^\d]/g, '');
    // let newVal = [...filteredData]
    // if (index >= 0 && index <= newVal?.length) {
    //   newVal[index].assignedRate = value
    //   setfilteredData(newVal)
    // }
    let value = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value) || value === '') {
        let newVal = [...filteredData];
        if (index >= 0 && index < newVal.length) {
            newVal[index].assignedRate = value; 
            setfilteredData(newVal);
        }
    }
  }

  const handleLoad = () => {

  }
  const handleSuccessModalClose = () => {
    setIsSuccess(false)
    getTableData()
  }
  const handleSearchData = (event, field) => {
    setSearchData({ ...searchData, [field]: event.target.value.toString() })
  }
  useEffect(() => {
    let fiterData = tableData.filter((val) =>
      (searchData?.PartyID === "" || (val?.PartyID && val?.PartyID?.toString().toLocaleLowerCase().includes(searchData?.PartyID?.toLocaleLowerCase()))) &&
      (searchData?.Party === "" || (val?.Party && val?.Party?.toLocaleLowerCase().includes(searchData?.Party?.toLocaleLowerCase()))) &&
      (searchData?.ServiceTypeID === "" || (val?.ServiceTypeID && val?.ServiceTypeID?.toString().toLocaleLowerCase().includes(searchData?.ServiceTypeID?.toLocaleLowerCase()))) &&
      (searchData?.ServiceType === "" || (val?.ServiceType && val?.ServiceType?.toLocaleLowerCase().includes(searchData?.ServiceType?.toLocaleLowerCase()))) &&
      (searchData?.ConsignmentID === "" || (val?.ConsignmentID && val?.ConsignmentID?.toString().toLocaleLowerCase().includes(searchData?.ConsignmentID?.toLocaleLowerCase()))) &&
      (searchData?.ConsignmentType === "" || (val?.ConsignmentType && val?.ConsignmentType?.toLocaleLowerCase().includes(searchData?.ConsignmentType?.toLocaleLowerCase()))) &&
      (searchData?.BillingUnitName === "" || (val?.BillingUnitName && val?.BillingUnitName?.toLocaleLowerCase().includes(searchData?.BillingUnitName?.toLocaleLowerCase()))) &&
      (searchData?.SourceCity === "" || (val?.SourceCity && val?.SourceCity?.toLocaleLowerCase().includes(searchData?.SourceCity?.toLocaleLowerCase()))) &&
      (searchData?.DestinationCity === "" || (val?.DestinationCity && val?.DestinationCity?.toLocaleLowerCase().includes(searchData?.DestinationCity?.toLocaleLowerCase()))) &&
      (searchData?.assignedRate === "" || (val?.assignedRate && val?.assignedRate?.toString().toLocaleLowerCase().includes(searchData?.assignedRate?.toLocaleLowerCase()))) &&
      (searchData?.ModifiedBy === "" || (val?.ModifiedBy && val?.ModifiedBy?.toLocaleLowerCase().includes(searchData?.ModifiedBy?.toLocaleLowerCase()))) &&
      (searchData?.ModifiedDate === "" || (val?.ModifiedDate && val?.ModifiedDate?.toString().toLocaleLowerCase().includes(searchData?.ModifiedDate?.toLocaleLowerCase())))
    );
    setfilteredData(fiterData);
  }, [searchData]);

  const PartyRateMatrixRow = (props) => {
    const { item, index } = props
    return (
      <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '36px' }}>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '2.54%', padding: '6px', textAlign: 'right' }}> {index + 1} </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4.42%', padding: '6px' }}>
          {item.PartyID}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '10.41%', padding: '6px', maxWidth: '120px' }}>
          <Tooltip title={`${item.Party}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
              {item.Party}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4.94%', padding: '6px', maxWidth: '120px' }}>
          {item.ServiceTypeID}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '7.04%', padding: '6px', maxWidth: '120px' }}>
          <Tooltip title={`${item.ServiceType}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.ServiceType}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '5.2%', padding: '6px' }}>{item.ConsignmentID}</TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.69%', padding: '6px', maxWidth: '116px' }}>
          <Tooltip title={`${item.ConsignmentType}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.ConsignmentType}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '7.04%', padding: '6px', maxWidth: '94px' }}>
          <Tooltip title={`${item.BillingUnitName}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.BillingUnitName}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
          <Tooltip title={`${item.SourceCity}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.SourceCity}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
          <Tooltip title={`${item.DestinationCity}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.DestinationCity}
            </span>
          </Tooltip>
        </TableCell>
        {item.editBtn ? <TableCell style={{ ...cellStyles, width: '5.69%', textAlign: 'right' }}> {item.assignedRate} </TableCell> :
          <TableCell className="input--wrapper" style={{ ...cellStyles, padding: '4px 4px', width: '5.69%', }}>
            <Item sx={{ padding: '0px' }}>
              <input
                id={`prmRate-${index}`}
                name={`prmRate-${index}`}
                className='input--style'
                autoFocus={manageFocus}
                style={{ fontSize: "12px", textAlign: "right", maxHeight: '27px' }}
                value={item?.assignedRate || ''}
                onChange={(e) => handleInputChange(e, index)}
              />
            </Item>
          </TableCell>}
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.69%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
          <Tooltip title={`${item.ModifiedBy}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.ModifiedBy}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.77%', padding: '6px', textAlign: 'left' }}>{item?.ModifiedDate}</TableCell>
        {item.editBtn ?
          <TableCell sx={{ ...cellStyles, width: '4.34%', textAlign: 'center' }}>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
              {item.active === 1 ? <CheckMarkSvg /> : <XMarkSvg />}
            </span></TableCell>
          : <TableCell style={{ ...cellStyles, width: '4.34%', padding: '0px 0px', textAlign: 'center' }}>
            <Item sx={{ width: '100%', padding: '0px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FormControlLabel
                value="end"
                sx={{ marginX: '0px', maxHeight: '36px' }}
                control={
                  <Checkbox
                    id={`chkbox-${index}`}
                    checked={item.active === 1}
                    onChange={(e) => handleRowChkChange(e, index)}
                    sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                  />
                }
                labelPlacement="end"
              />
            </Item>
          </TableCell>}
        {item.editBtn ? <TableCell style={{ ...cellStyles, width: '5.17%' }}>
          <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px' }}
            onClick={() => { handleHideEditBtn(index) }}
            onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'selectParty' : `editBtn-${index + 1}`, index === 0 ? "AddPartyRateBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index); })}
          >
            <EditIcon sx={{ marginRight: '3px' }} />
            Edit
          </span></TableCell> :
          <TableCell style={{ ...cellStyles, width: '5.17%', padding: '0px 0px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                onClick={() => { setEditData(item); handleRowEdit(item, index) }}
                style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px' }}
              >
                <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50', marginTop: '1px' }} fontSize='large' />
              </span>
              <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`}
                onClick={() => handleCrossBtn(index)}
                style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px' }}
              >
                <CancelOutlinedIcon tabIndex={0} style={{ color: 'red', marginTop: '1px' }} fontSize="large" />
              </span>
            </div>
          </TableCell>}
      </TableRow>
    )
  }
  return (
    <>
      <Stack style={{ padding: '5px 0px', display: 'flex', flexDirection: 'row', gap: '16px' }} className="itemButtons">
        <Item sx={sx.itemsx}>
          <DropDownOA
            id='selectParty'
            label={'Select Party'}
            data={partyList || []}
            width="100%"
            defaultvalue={filters?.partyName?.Party}
            value={filters?.partyName?.Party}
            searchPlaceholder={`Search City Name`}
            dataKey={`Party`}
            idKey={`PartyID`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                partyName: val
              }))
            }}
            onSelResetVal={true}
            nextId={'serviceType'}
            prevId={'AddPartyRateBtn'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id='serviceType'
            label={'Service Type'}
            data={serviceTypeList || []}
            width="100%"
            defaultvalue={filters?.serviceType?.name}
            value={filters?.serviceType?.name}
            searchPlaceholder={`Search City Name`}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                serviceType: val
              }))
            }}
            // onReset
            onSelResetVal={true}
            nextId={'ConsignmentType'}
            prevId={'selectParty'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id='ConsignmentType'
            label={'Consignment Type'}
            data={consTypeList || []}
            width="100%"
            defaultvalue={filters?.consignmentType?.name}
            value={filters?.consignmentType?.name}
            searchPlaceholder={`Search City Name`}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                consignmentType: val
              }))
            }}
            onSelResetVal={true}
            nextId={'billingUnit'}
            prevId={'serviceType'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id='billingUnit'
            label={'Billing Unit'}
            data={billingUnitList || []}
            width="100%"
            defaultvalue={filters?.billingUnit?.name}
            value={filters?.billingUnit?.name}
            searchPlaceholder={`Search Billing Unit`}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                billingUnit: val
              }))
            }}
            onSelResetVal={true}
            nextId={'status'}
            prevId={'ConsignmentType'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id='status'
            label={'Status'}
            data={statusListWithAll || []}
            width="100%"
            defaultvalue={filters?.status?.name}
            value={filters?.status?.name}
            searchPlaceholder={`Search Status`}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                status: val
              }))
            }}
            onSelResetVal={true}
            nextId={'loadBtn'}
            prevId={'billingUnit'}
          />
        </Item>
        <Button
          id="loadBtn"
          style={{ margin: '0', height: "40px", width: '81px' }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={() => {
            getTableData()
          }}
          onKeyDown={(e) => navigation3(e, 'AddPartyRateBtn', 'status', () => { })}

        >
          load
        </Button>
        <Button
          variant="outlined"
          id={'AddPartyRateBtn'}
          sx={{ width: '130px', padding: '5px', }}
          className="receiveitembtn"
          onKeyDown={(e) => navigation3(e, filteredData?.length > 0 ? 'editBtn-0' : 'selectParty', 'loadBtn', () => { getAddPartyRatesModalInfo() })}
          onClick={() => {
            getAddPartyRatesModalInfo()
          }}
        >
          + add new
        </Button>
        <Box >
          <Button
            variant="outlined"
            id={'AddPartyRateBtn'}
            sx={{ width: '130px', padding:'5px' }}
            className="receiveitembtn"
            // onKeyDown={(e) => navigation3(e, filteredData?.length > 0 ? 'editBtn-0' : 'selectParty', 'loadBtn', () => { getAddPartyRatesModalInfo() })}
            onClick={() => {
              clickElement('xls-buttons-dispatch')
            }}
          >
            Excel
          </Button>
          <ReactHtmlTableToExcel
            id="xls-buttons-dispatch"
            table="tableExcel"
            filename={'View Rate Matrix'}
            sheet="sheet 1"
            buttonText="EXPORT AS EXCEL"
            className="excel-button"
          />
        </Box>
      </Stack>
      <Stack style={{ maxHeight: '60vh', marginTop: '7px' }}>
        <TableContainer
          className="lr-popup-table lrModel  scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="partyRateMatrixTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff' }}>
                {columnDefs.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {col?.headerName?.split('\n')?.map((line, lineIndex) => (
                        <span key={`line-${lineIndex}`} style={{}}>
                          {line}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {columnDefs.map((col, index) =>
                  col.showfilter ? (
                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                      <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                        <input
                          id={`index-${index}`}
                          className="field"
                          name="cancelSearchInput"
                          style={{ width: '100%', height: '24px' }}
                          placeholder="Contains"
                          value={searchData[col.field]}
                          onChange={(e) => handleSearchData(e, col.field)}
                        />
                        <FilterAltIcon style={{ color: '#aaa' }} />
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell key={`empty-cell-${index}`}></TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            {filteredData?.length > 0 ? (
              <>
                <TableBody className="filter-data-row" style={{ border: 'none' }}>
                  {filteredData?.map((item, index) => (
                    <PartyRateMatrixRow item={item} index={index} key={index} />
                  ))}
                </TableBody>
              </>
            ) : (
              <>
                <TableBody>
                  <EmptyTableRow />
                </TableBody>
              </>
            )}
          </Table>
          <Table
            style={{ display: 'none', border: 'none', overflow: 'auto' }}
            stickyHeader
            id="tableExcel"
            className="table1 table-Received"
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={Math.floor(columnDefs1.length / 2)}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Party Rate Matrix</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={columnDefs1.length - Math.floor(columnDefs1.length / 2)}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={columnDefs1.length}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={3}
                >
                 Select Party
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={3}
                >
                 Service Type
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={3}
                >
                 Consignment Type
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={3}
                >
                Billing Unit
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={2}
                >
                Status
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                {filters?.partyName?.Party}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                {filters?.serviceType?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                 {filters?.consignmentType?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                {filters?.billingUnit?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                {filters?.status?.name}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={columnDefs1.length}></TableCell>
              </TableRow>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff' }}>
                {columnDefs1.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>

            </TableHead>
            {filteredData?.length > 0 ? (
              <>
                <TableBody className="filter-data-row" style={{ border: 'none' }}>
                  {filteredData?.map((item, index) => (
                    <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '36px' }}>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '2.54%', padding: '6px', textAlign: 'right' }}> {index + 1} </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4.42%', padding: '6px' }}>
                        {item.PartyID}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '10.41%', padding: '6px', maxWidth: '120px' }}>
                        {item.Party}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4.94%', padding: '6px', maxWidth: '120px' }}>
                        {item.ServiceTypeID}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '7.04%', padding: '6px', maxWidth: '120px' }}>
                        {item.ServiceType}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '5.2%', padding: '6px' }}>{item.ConsignmentID}</TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.69%', padding: '6px', maxWidth: '116px' }}>
                        {item.ConsignmentType}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '7.04%', padding: '6px', maxWidth: '94px' }}>
                        {item.BillingUnitName}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
                        {item.SourceCity}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
                        {item.DestinationCity}
                      </TableCell>
                      <TableCell style={{  fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}> {item.assignedRate} </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.69%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
                        {item.ModifiedBy}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.77%', padding: '6px', textAlign: 'left' }}>{item?.ModifiedDate}</TableCell>
                      <TableCell sx={{  fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px', width: '4.34%', textAlign: 'center' }}>
                        {item.active === 1 ? 'Active' : 'InActive'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </>
            ) : (
              <>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={columnDefs1?.length}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '15px',
                            marginBottom: '15px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          <span>No results found.</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
              </>
            )}
          </Table>
        </TableContainer>
      </Stack>
      {showAddPartyRateModal && <AddNewPartyRatesModal dataValues={addPartyRateData} updateModal={setShowAddPartyRateModal} />}
      <SuccessAndErrorModal handleClose={() => { handleSuccessModalClose() }} open={isSuccess} title={'Party Rate Updated Successfully!'} modalStyle={modalStyle} />
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { updateAlertError, getFocApprConsTypeData, getPartyConfigTableData, getPartyRateMatrixTableData, getParyRateUpdate, getCityList }
export default connect(mapStateToProps, mapDispatchToProps)(PartyRateMatrixTable)
